/** Shopify CDN: Minification failed

Line 61:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 62:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 88:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 93:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 103:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 107:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 109:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 120:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 21 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 46:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 47:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 78:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 88:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 94:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 105:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 21 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 32:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 63:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 73:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 79:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 90:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 21 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 17:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 28:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 58:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:9 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 64:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 75:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 21 more hidden warnings

**/
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.modal = this.closest('.search-modal');
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.querySelector('form.search').addEventListener('submit', this.onFormSubmit.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    this.querySelector('button[type="reset"]').addEventListener('click', this.clear.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (searchTerm.length === 0) {
      this.clear();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    document.body.classList.add('predictive-search--focus');
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  } 

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.clear(event);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;
    
    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = ''; 

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);
 
    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const perPage = this.dataset.perPage || 4;
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      if (this.modal) this.modal.classList.add('searching');
      return;
    }

    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=${perPage}&section_id=predictive-search`)
      .then((response) => { 
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
        
        if (this.modal) this.modal.classList.add('searching');
      })
      .catch((error) => {
        this.close();
        throw error;
      }); 
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);  

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() { 
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    document.body.classList.add('predictive-search--focus');
  }

  close() {
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    document.body.classList.remove('predictive-search--focus');
  }

  clear(event) {
    event.preventDefault();
    
    this.input.value = '';
    this.removeAttribute('open');
    this.removeAttribute('results');
    this.input.focus();

    if (this.modal) this.modal.classList.remove('searching');
  }
}

customElements.define('predictive-search', PredictiveSearch);
